<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M54 18.06L33 5.85a2 2 0 00-2 0L10 18.06a2 2 0 00-1 1.73v24.42a2 2 0 001 1.73l21 12.21a2 2 0 001 .27 2 2 0 001-.27l21-12.21a2 2 0 001-1.73V19.79a2 2 0 00-1-1.73zM32 8.74L50.52 19.5 32 30.26 13.48 19.5zM12 22.11l18.5 10.75v21.53L12 43.64zm21.5 32.28V32.86L52 22.11v21.53z"/></svg>